import { closeMenu, setActiveMenu } from './nav-utils'

let el = null,
  menuButtons = null,
  submenuActive = false

const submenus = []

const selectFocusableElements = (targetEl) => {
  return targetEl.querySelectorAll(
    'button:not([tabindex="-1"]), a, input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"]'
  )
}

const switchMainMenu = (direction = 'bottom') => {
  // submenuActive = false;
  el.props.submenuActive = false

  let nextActiveMenu = null

  if (direction === 'bottom') {
    if (el.props.activeMenu + 1 == menuButtons.length) {
      nextActiveMenu = 0
    } else {
      nextActiveMenu = el.props.activeMenu + 1
    }
  } else {
    if (el.props.activeMenu - 1 < 0) {
      nextActiveMenu = menuButtons.length - 1
    } else {
      nextActiveMenu = el.props.activeMenu - 1
    }
  }

  menuButtons[nextActiveMenu].focus()

  window.requestAnimationFrame(() => {
    let focusableEls = submenus[el.props.activeMenu]

    if (focusableEls.length > 0) {
      // submenuActive = true;
      el.props.submenuActive = true

      if (direction === 'top') {
        focusableEls[focusableEls.length - 1].focus()
      } else {
        focusableEls[0].focus()
      }
    }
  })
}

const tabFunction = (e) => {
  // main menu
  // if (!submenuActive) {
  if (!el.props.submenuActive) {
    if (el.props.activeMenu === 0 && e.shiftKey) {
      e.preventDefault()
      menuButtons[menuButtons.length - 1].focus()
    }

    // last item
    if (el.props.activeMenu + 2 > menuButtons.length) {
      if (!e.shiftKey) {
        e.preventDefault()
        menuButtons[0].focus()
      }
    }
  }

  // sub menu tabs

  // if (submenuActive) {
  if (el.props.submenuActive) {
    // let activeMenu = submenus;

    let isFirst = submenus[el.props.activeMenu][0] === document.activeElement
    let isLast =
      submenus[el.props.activeMenu][
        submenus[el.props.activeMenu].length - 1
      ] === document.activeElement

    if (isFirst && e.shiftKey) {
      e.preventDefault()
      switchMainMenu('top')
    }

    if (isLast && !e.shiftKey) {
      e.preventDefault()
      switchMainMenu('bottom')
    }
  }
}

const topBottomArrowsFunction = (key) => {
  if (el.props.submenuActive) {
    let currentMenuItem = null

    submenus[el.props.activeMenu].forEach((item, index) => {
      if (item === document.activeElement) {
        currentMenuItem = index
      }
    })

    if (key === 'ArrowDown') {
      currentMenuItem + 1 === submenus[el.props.activeMenu].length
        ? switchMainMenu('bottom')
        : submenus[el.props.activeMenu][currentMenuItem + 1].focus()
    }

    if (key === 'ArrowUp') {
      currentMenuItem - 1 < 0
        ? switchMainMenu('top')
        : submenus[el.props.activeMenu][currentMenuItem - 1].focus()
    }
  } else {
    if (key === 'ArrowDown') {
      el.props.activeMenu + 1 === menuButtons.length
        ? setActiveMenu(el, 0)
        : setActiveMenu(el, el.props.activeMenu + 1)
      menuButtons[el.props.activeMenu].focus()
    }

    if (key === 'ArrowUp') {
      el.props.activeMenu - 1 >= 0
        ? setActiveMenu(el, el.props.activeMenu - 1)
        : setActiveMenu(el, menuButtons.length - 1)
      menuButtons[el.props.activeMenu].focus()
    }
  }
}

const leftRightArrowsFunction = (key) => {
  if (key === 'ArrowLeft') {
    el.props.submenuActive = false
    el.querySelector('.nav__main-menu-link--active').focus()
  }

  if (key === 'ArrowRight') {
    let focusableEls = selectFocusableElements(
      el.querySelector('.nav__secondary-menu__item--visible')
    )

    if (focusableEls.length > 0) {
      el.props.submenuActive = true
      focusableEls[0].focus()
    }
  }
}

const keyEvents = (e) => {
  if (e.key == 'Escape') {
    closeMenu(el)

    // el.props.submenuActive = false;
  }

  if (e.key == 'ArrowUp' || e.key == 'ArrowDown') {
    e.preventDefault()
    topBottomArrowsFunction(e.key)
  }

  if (e.key == 'ArrowLeft' || e.key == 'ArrowRight') {
    leftRightArrowsFunction(e.key)
  }

  if (e.key == 'Tab') {
    tabFunction(e)
  }
}

let keyDownListeners = (ell, init) => {
  if (init) {
    el = ell
    menuButtons = el.querySelectorAll('.nav__main-menu-link')
    menuButtons[0].focus()

    menuButtons.forEach((menuButton) => {
      let submenu = document.getElementById(
        menuButton.getAttribute('data-targetmenu')
      )

      if (submenu) {
        submenus.push(selectFocusableElements(submenu))
      }
    })

    window.addEventListener('keydown', keyEvents)
  } else {
    window.removeEventListener('keydown', keyEvents)
    el = null
  }
}

export default keyDownListeners
